export const APIEndpoints = {
  FetchVendorsList: '/v0/service/vendor/list',
  ValidateThirdPartyVendorToken:
    '/v0/rag/workflows/multi_file_va/vendor/validate-token',
  SendThirdPartyVendorFormEmail:
    '/v0/rag/workflows/multi_file_va/vendor/send-email',
  SubmitThirdPartyVendorForm:
    'v0/rag/workflows/multi_file_va/vendor/intake-form',
};
